var React = require('react');

function DesktopAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M528 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 288H64V64h448z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 64v224h448V64zm360 400h-72l-16-48h-96l-16 48h-72a24 24 0 0 0 0 48h272a24 24 0 0 0 0-48z","className":"fa-primary","key":2})]);
}

DesktopAlt.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = DesktopAlt;

DesktopAlt.default = DesktopAlt;
